import { render, staticRenderFns } from "./ContestsHome.vue?vue&type=template&id=fb8c680e&scoped=true"
import script from "./ContestsHome.vue?vue&type=script&setup=true&lang=js"
export * from "./ContestsHome.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8c680e",
  null
  
)

export default component.exports